var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoGuideQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#16BAB6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9653_29753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C2.69119 12 0 9.30866 0 6.00033C0 2.69201 2.69119 0 6 0C9.30881 0 12 2.69134 12 6.00033C12 9.30933 9.30881 12 6 12ZM6 0.664857C3.05817 0.664857 0.66482 3.05834 0.66482 6.00033C0.66482 8.94232 3.05817 11.3351 6 11.3351C8.94183 11.3351 11.3352 8.94166 11.3352 6.00033C11.3352 3.05901 8.94116 0.664857 6 0.664857Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9653_29753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60639 8.52434C6.60668 8.92344 6.29079 9.22701 5.87844 9.22389C5.46617 9.22076 5.16172 8.92295 5.16408 8.52519C5.16636 8.12758 5.47625 7.82344 5.8783 7.82422C6.29393 7.825 6.60618 8.12524 6.60639 8.52434Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50113 5.64377C7.33653 5.80614 7.15935 5.9565 6.98232 6.10566C6.65656 6.38011 6.44649 6.70932 6.44928 7.14884C6.44949 7.17392 6.41617 7.22094 6.39801 7.22115C6.03214 7.22541 5.66613 7.22435 5.28946 7.22435C5.28067 6.95352 5.29733 6.69746 5.37333 6.44652C5.46721 6.13649 5.65748 5.88853 5.88642 5.66756C6.08162 5.47913 6.2859 5.29993 6.48203 5.11227C6.64862 4.95296 6.76288 4.76416 6.78283 4.52864C6.8273 4.00524 6.52478 3.65301 5.99611 3.61345C5.43118 3.57112 5.05265 3.86077 4.95048 4.41343C4.94526 4.44177 4.93704 4.47018 4.93618 4.49866C4.9336 4.58581 4.89085 4.61309 4.80412 4.61174C4.49537 4.60691 4.18649 4.60464 3.87789 4.61131C3.76921 4.61366 3.74419 4.5802 3.75105 4.47622C3.81683 3.4873 4.47421 2.78889 5.47293 2.65543C5.93304 2.59392 6.3845 2.62105 6.82566 2.7793C8.18117 3.26563 8.30122 4.8548 7.50113 5.64377Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9653_29753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9653_29753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.24951,
    height: 6.60031,
    fill: "white",
    transform: "translate(3.75 2.625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGuideQuestionMark);
export default __webpack_public_path__ + "static/media/video_guide_question_mark.04f08a3d.svg";
export { ForwardRef as ReactComponent };